import { ConditionalWrapper, classNames } from "@/lib/utils";
import Tooltip from "@components/library/Tooltip";
import { Dayjs } from "dayjs";
import { None } from "../Tables/Logs/LogCells";
import { capitalize } from "lodash";
import React from "react";
import { RelativeTimestamp } from "@components/atoms/Timestamp";
type DataDisplayBaseProps = {
  label: string;
  size?: "sm" | "lg";
  loading?: boolean;
  tooltipContent?: React.ReactNode;
  valueClassName?: string;
};

type DataDisplayProps = DataDisplayBaseProps &
  ({ value: React.ReactNode; loading?: never } | { value?: React.ReactNode; loading: boolean });

export const DataDisplay = ({ label, value, size, loading, tooltipContent, valueClassName }: DataDisplayProps) => (
  <dl className={classNames("flex flex-col", size === "sm" ? "gap-4" : "gap-8")}>
    <DisplayLabel>{label}</DisplayLabel>
    <ConditionalWrapper
      condition={tooltipContent !== undefined}
      wrapper={(children) => <Tooltip content={tooltipContent}>{children}</Tooltip>}
    >
      <dd className="text-text-text-base-1 flex min-h-[26px] items-center text-13-20">
        {loading ? (
          <span className="font-mono text-text-base-4">loading...</span>
        ) : !value ? (
          <None />
        ) : (
          <span className={valueClassName}>{value}</span>
        )}
      </dd>
    </ConditionalWrapper>
  </dl>
);

type DataDisplayDateProps = DataDisplayBaseProps & { datetime?: Dayjs };

export const DataDisplayDate = ({ datetime, ...props }: DataDisplayDateProps) => (
  <DataDisplay {...props} value={datetime ? <RelativeTimestamp timestamp={datetime} /> : null} />
);

export const DisplayLabel = ({ children }: { children: React.ReactNode }) => (
  <dt className="text-13-14 font-medium text-text-base-3">{children}</dt>
);
